module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    key: _vm.componentKey,
    staticClass: "row",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h6', [_vm._v("Group")]), _vm._v(_vm._s(_vm.group) + "\r\n        "), (_vm.menu_view.showDisplayMembers) ? _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.display_members), function(member) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "60px",
        "height": "65px"
      }
    }, [_c('img', {
      attrs: {
        "src": member.data_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "80%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 colx"
    }, [_c('div', {
      staticClass: "col-xs-9 colx"
    }, [_c('p', [_c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(member.data_username))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v(_vm._s(member.data_name)), _c('br')]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "100%",
        "font-weight": "lighter"
      }
    }, [_vm._v(_vm._s(member.data_category))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 colx"
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      on: {
        "click": function($event) {
          _vm.setAddMemberToGroup(member)
        }
      }
    }, [_vm._v("\r\n                      Add\r\n                    ")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('br')], 2) : _c('div', [_c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Enter username  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_member.username),
      expression: "search_member.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.search_member.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_member.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.searchMember
    }
  }, [_vm._v("Enter gty66")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_title),
      expression: "post.post_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setAddGroupPost
    }
  }, [_vm._v("Post")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('')
      }
    }
  }, [_vm._v("\r\n                Cancel\r\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#21a6f3",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuComponent('showCreateGroup')
      }
    }
  }, [_vm._v("\r\n            Add New Member\r\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7345b44"}!./src/pages/Account/Groups/Group/template.html
// module id = 589
// module chunks = 0